<template>
    <div class="indicatCom">
        <div class="indicatbox">
            <div class="wz_content clearFloat" v-show="config.show">
                <i class="iconfont"
                   :class="config.iconSet.name"
                   :style="{
                       width:config.iconSet.fontSize+'px',
                       fontSize:config.iconSet.fontSize+'px',
                       float:config.iconSet.position,
                       color:config.iconSet.color,
                       lineHeight:config.iconSet.lineHeight+'px',
                }" v-if="config.iconSet.show"></i>
                <div  :style="{
                      width:config.iconSet.show ? 'calc(100% - '+config.iconSet.fontSize+'px)':'100%',
                      paddingLeft:config.textSet.paddingLeft+'px',
                      paddingRight:config.textSet.paddingRight+'px',
                      float: config.iconSet.show ? 'right':'left'
                }" >
                    <p :style="{
                            color:config.textSet.font.color,
                            fontSize:config.textSet.font.fontSize+'px',
                            fontWeight:config.textSet.font.fontWeight,
                            fontFamily:config.textSet.font.fontFamily,
                            top:config.paddingTop+'px',
                             width: 'calc(100% - ' + config.textSet.paddingLeft+'px - ' + config.textSet.paddingRight + 'px) ',
                            textAlign:config.textSet.position
                        }" v-show="config.textSet.show">{{config.textSet.text}}</p>
                    <p :style="{
                             bottom:config.paddingBottom+'px',
                            width: 'calc(100% - ' + config.textSet.paddingLeft+'px - ' + config.textSet.paddingRight + 'px) ',
                             textAlign:config.valSet.position
                        }">
                        <span :style="{
                            color:config.valSet.font.color,
                            fontSize:config.valSet.font.fontSize+'px',
                            fontWeight:config.valSet.font.fontWeight,
                            fontFamily:config.valSet.font.fontFamily,
                        }">{{config.valSet.val}}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/17 4:58 下午
     */
    export default {
        name: 'indicatCom',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            option: {
                type: Object,
                default:()=>{}
            }
        },
        data() {
            return {

            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    @import "../iocnfont/iconfont.css";
    .indicatCom {
        .indicatbox{
            width: 100%;
            height: 100%;
            /*margin:0px auto;*/
            /*padding-top: 100px;*/
            .wz_content{
                width: 100%;
                height: 100%;
                >i{
                    width: 70px;
                    height: 100%;
                    background-size: 100% 100%;
                    display: block;
                    float: left;
                    line-height: 70px;
                }
                >div{
                    height: 100%;
                    padding-left: 20px;
                    width: calc(100% - 70px);
                    float: right;
                    position: relative;
                    p{
                        font-size: 22px;
                        color: #313b46;
                        position: absolute;

                        &:last-child{
                            color: #4d4f51;
                            span{
                                display: inline-block;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
